import i18n from "i18next";

// Format a date value for CSV export. Returns "" for missing/invalid dates so
// empty cells stay empty instead of rendering "Invalid Date".
const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
};

const exportAllExports = {
  pdfExportHeaders() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      {
        label: i18n.t("exports.headers.name", { ns: "statistics" }),
        key: "name",
      },
      { label: i18n.t("exports.headers.ec7", { ns: "statistics" }), key: "ec7" },
      { label: i18n.t("exports.headers.germany", { ns: "statistics" }), key: "germany" },
      { label: i18n.t("exports.headers.aashto", { ns: "statistics" }), key: "aashto" },
      { label: i18n.t("exports.headers.fhwa", { ns: "statistics" }), key: "fhwa" },
      { label: i18n.t("exports.headers.en", { ns: "statistics" }), key: "en" },
      { label: i18n.t("exports.headers.de", { ns: "statistics" }), key: "de" },
      { label: i18n.t("exports.headers.es", { ns: "statistics" }), key: "es" },
    ];
  },

  pdfExport(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return {
        name: val.name,
        ec7: val.ec7,
        germany: val.germany,
        aashto: val.aashto,
        fhwa: val.fhwa,
        en: val.en,
        de: val.de,
        es: val.es,
        length: new Intl.NumberFormat().format(val.length),
      };
    });
  },

  pdfExportHeadersFull() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.date", { ns: "statistics" }), key: "exportAt" },
      { label: i18n.t("exports.headers.userName", { ns: "statistics" }), key: "userName" },
      { label: i18n.t("exports.headers.surname", { ns: "statistics" }), key: "surname" },
      { label: i18n.t("exports.headers.company_name", { ns: "statistics" }), key: "company_name" },
      { label: i18n.t("exports.headers.email", { ns: "statistics" }), key: "email" },
      {
        label: i18n.t("exports.headers.name", { ns: "statistics" }),
        key: "carryingElement",
      },
      {
        label: i18n.t("exports.headers.berechnungsmodus", { ns: "statistics" }),
        key: "berechnungsModus",
      },
      { label: i18n.t("exports.headers.length", { ns: "statistics" }), key: "length" },
      { label: i18n.t("exports.headers.language", { ns: "statistics" }), key: "language" },
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "userCountry" },
      { label: i18n.t("exports.headers.userId", { ns: "statistics" }), key: "userId" },
    ];
  },

  pdfExportFull(exports) {
    if (!exports) {
      return [];
    }
    return exports?.map((val) => {
      return {
        userName: val.userName,
        surname: val.surname,
        company_name: val.company_name,
        email: val.email,
        carryingElement: val.carryingElement,
        berechnungsModus:
          val.berechnungsModus === 0
            ? "EC7"
            : val.berechnungsModus === 1
              ? "EC7 DIBt"
              : val.berechnungsModus === 2
                ? "AASHTO"
                : "FHWA",
        length: new Intl.NumberFormat().format(val.length),
        exportAt: formatDate(val.exportAt),
        language: val.language,
        userCountry: val.userCountry,
        userId: val.userId,
      };
    });
  },

  headersBrutto() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      {
        label: i18n.t("exports.headers.year", { ns: "statistics" }),
        key: "year",
      },
      { label: i18n.t("exports.headers.month", { ns: "statistics" }), key: "month" },
      { label: i18n.t("exports.headers.count", { ns: "statistics" }), key: "count" },
    ];
  },

  exportBrutto(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return {
        year: val._id.year,
        month: val._id.month,
        count: val.logins,
      };
    });
  },

  headersNetto() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      {
        label: i18n.t("exports.headers.year", { ns: "statistics" }),
        key: "year",
      },
      { label: i18n.t("exports.headers.month", { ns: "statistics" }), key: "month" },
      { label: i18n.t("exports.headers.count", { ns: "statistics" }), key: "count" },
    ];
  },

  exportNetto(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return {
        year: val._id.year,
        month: val._id.month,
        count: val.count,
      };
    });
  },

  headersDuration() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.year", { ns: "statistics" }), key: "year" },
      { label: i18n.t("exports.headers.month", { ns: "statistics" }), key: "month" },
      { label: i18n.t("exports.headers.duration", { ns: "statistics" }), key: "duration" },
    ];
  },

  exportDuration(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return {
        year: val._id.year,
        month: val._id.month,
        duration: new Intl.NumberFormat().format(val.duration),
      };
    });
  },

  headersUsersPerCountry() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "country" },
      { label: i18n.t("exports.headers.count", { ns: "statistics" }), key: "count" },
    ];
  },

  exportUsersPerCountry(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return { country: val._id.country, count: val.count };
    });
  },

  headersRegistrationsPerMonth() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.year", { ns: "statistics" }), key: "year" },
      { label: i18n.t("exports.headers.month", { ns: "statistics" }), key: "month" },
      { label: i18n.t("exports.headers.count", { ns: "statistics" }), key: "count" },
    ];
  },

  exportRegistrationsPerMonth(exports) {
    if (!exports) {
      return [];
    }

    return exports.map((val) => {
      return { year: val._id.year, month: val._id.month, count: val.count };
    });
  },

  headersRegistrationsFull() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.userName", { ns: "statistics" }), key: "userName" },
      { label: i18n.t("exports.headers.surname", { ns: "statistics" }), key: "surname" },
      { label: i18n.t("exports.headers.company_name", { ns: "statistics" }), key: "company_name" },
      { label: i18n.t("exports.headers.email", { ns: "statistics" }), key: "email" },
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "userCountry" },
      { label: i18n.t("exports.headers.date", { ns: "statistics" }), key: "userRegistration" },
      {
        label: i18n.t("exports.headers.userId", { ns: "statistics" }),
        key: "userId",
      },
    ];
  },

  exportRegistrationsFull(exports) {
    return exports?.map((val) => {
      return {
        userName: val.userName,
        surname: val.surname,
        company_name: val.company_name,
        email: val.email,
        userId: val.userId,
        userCountry: val.userCountry,
        userRegistration: formatDate(val.userRegistration),
      };
    });
  },

  headersUserIteractionsFull() {
    i18n.loadNamespaces(["translation", "statistics"]);

    return [
      { label: i18n.t("exports.headers.userName", { ns: "statistics" }), key: "userName" },
      { label: i18n.t("exports.headers.surname", { ns: "statistics" }), key: "surname" },
      { label: i18n.t("exports.headers.company_name", { ns: "statistics" }), key: "company_name" },
      { label: i18n.t("exports.headers.email", { ns: "statistics" }), key: "email" },
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "userCountry" },
      { label: i18n.t("exports.headers.lastLogin", { ns: "statistics" }), key: "lastLogin" },
      { label: i18n.t("exports.headers.lastSeenOn", { ns: "statistics" }), key: "lastSeenOn" },
      { label: i18n.t("exports.headers.loginCount", { ns: "statistics" }), key: "loginCount" },
      { label: i18n.t("exports.headers.duration", { ns: "statistics" }), key: "duration" },
      {
        label: i18n.t("exports.headers.userId", { ns: "statistics" }),
        key: "userId",
      },
    ];
  },

  exportUserIteractionsFull(exports) {
    return exports?.map((val) => {
      return {
        userName: val.userName,
        surname: val.surname,
        company_name: val.company_name,
        email: val.email,
        userId: val.userId,
        userCountry: val.userCountry,
        lastLogin: formatDate(val.lastLogin),
        lastSeenOn: formatDate(val.lastSeenOn),
        loginCount: val.loginCount,
        duration: val.duration,
      };
    });
  },

  geobimDownloadsHeadersFull() {
    i18n.loadNamespaces(["translation", "statistics"]);
    return [
      { label: i18n.t("exports.headers.date", { ns: "statistics" }), key: "downloadAt" },
      { label: i18n.t("exports.headers.userName", { ns: "statistics" }), key: "userName" },
      { label: i18n.t("exports.headers.surname", { ns: "statistics" }), key: "surname" },
      { label: i18n.t("exports.headers.company_name", { ns: "statistics" }), key: "company_name" },
      { label: i18n.t("exports.headers.email", { ns: "statistics" }), key: "email" },
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "userCountry" },
      { label: i18n.t("exports.headers.language", { ns: "statistics" }), key: "language" },
      { label: i18n.t("geobim.download_type", { ns: "statistics" }), key: "downloadType" },
      { label: i18n.t("geobim.version", { ns: "statistics" }), key: "version" },
      { label: i18n.t("geobim.file_size", { ns: "statistics" }), key: "fileSize" },
      { label: i18n.t("geobim.download_source", { ns: "statistics" }), key: "downloadSource" },
    ];
  },

  geobimDownloadsFull(exports) {
    if (!exports) return [];
    return exports.map((val) => ({
      downloadAt: formatDate(val.downloadAt),
      userName: val.userName,
      surname: val.surname,
      company_name: val.company_name,
      email: val.email,
      userCountry: val.userCountry,
      language: val.language,
      downloadType: val.downloadType,
      version: val.version,
      fileSize: val.fileSize,
      downloadSource: val.downloadSource,
    }));
  },

  wordExportHeadersFull() {
    i18n.loadNamespaces(["translation", "statistics"]);
    return [
      { label: i18n.t("exports.headers.date", { ns: "statistics" }), key: "exportAt" },
      { label: i18n.t("exports.headers.userName", { ns: "statistics" }), key: "userName" },
      { label: i18n.t("exports.headers.surname", { ns: "statistics" }), key: "surname" },
      { label: i18n.t("exports.headers.company_name", { ns: "statistics" }), key: "company_name" },
      { label: i18n.t("exports.headers.email", { ns: "statistics" }), key: "email" },
      { label: i18n.t("exports.headers.country", { ns: "statistics" }), key: "userCountry" },
      { label: i18n.t("exports.headers.language", { ns: "statistics" }), key: "language" },
      { label: i18n.t("exports.headers.name", { ns: "statistics" }), key: "carryingElement" },
      {
        label: i18n.t("wordexport.selected_options", { ns: "statistics" }),
        key: "selectedOptions",
      },
    ];
  },

  wordExportFull(exports) {
    if (!exports) return [];
    return exports.map((val) => ({
      exportAt: formatDate(val.exportAt),
      userName: val.userName,
      surname: val.surname,
      company_name: val.company_name,
      email: val.email,
      userCountry: val.userCountry,
      language: val.language,
      carryingElement: val.carryingElement,
      selectedOptions: (val.selectedOptions ?? [])
        .map((opt) => i18n.t(`createlv.${opt}`, { ns: "translation", defaultValue: opt }))
        .join(", "),
    }));
  },
};

export default exportAllExports;
